module.exports = __webpack_public_path__ + "static/media/m15tj93.4ef1131d.png";